module.exports = __webpack_public_path__ + "assets/loop-editor-active.c7ab0720.svg";